<div [ngClass]="showOverlay ? 'spinner-overlay' : isInternal ? 'internal-spinner' : '' ">
    <div [ngClass]="!isInternal ? 'spinner-container' : '' ">
        <img src="/assets/spinner.gif" class="spinner" />
    </div>
</div>
